module.exports = __webpack_public_path__ + "img/collection-diamondJewelryColliers.e9d83c5.jpg";